import React, { useEffect, useRef, useState } from "react";
import AccountsButton from "../Accounts/AccountsButton";
import SideMenu from "../General/SideMenu";
import MasterList from "../Master/MasterListItem";
import DebitCreditBody from "./DebitCreditBody";
import $ from "jquery";
import { useDispatch, useSelector } from "react-redux";
import Messagedialogbox, {
  Ask_Question,
  Show_Message,
} from "../General/Messagedialogbox";
import {
  refresh_AccDebCrd,
  setDebCrdHT,
  setEntDebCrdHT,
  setAccDeCr_Taborder,
  setDebCrdDeafult,
  toISODate,
} from "../features/Accounts";
import { API_FETCH, API_POST, DecryptData } from "../General/Utility";

const toBool = (v) =>
  v === true || v === 1 || v === "1" || String(v).toLowerCase() === "true";
const isEmpty = (val) =>
  val === undefined || val === null || String(val).trim() === "";

function CreditNote() {
  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);
  const _AccParem = useSelector((state) => state.Accounts.DebitCredit);
  const _TabParem = useSelector((state) => state.Accounts.DebCrdTab);
  const _HTParem = useSelector((state) => state.Accounts.DebCrdHT);
  const [strSearch, setstrSearch] = useState("");
  // blocks a second Save while the first one is still running (double click)
  const savingRef = useRef(false);

  useEffect(() => {
    Load_CreditNote();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Redux Admin can be empty right after a page refresh, so fall back to the
  // encrypted values in localStorage.
  const sessionParams = async () => {
    const local = (await DecryptData(localStorage.jbctrlparams)) || {};
    return {
      Branch: Number(_AuthParems.Branch || local.Branch),
      DB: _AuthParems.DB || local.DB,
    };
  };

  const Load_CreditNote = async () => {
    const session = await sessionParams();
    const res = await API_FETCH(
      `CreditNote/Load_CreditNote/${session.Branch}/${session.DB}`,
      dispatch
    );
    if (res) {
      const objNo = (res.objEntNoFormat || [])[0];
      if (!objNo) {
        Show_Message(
          dispatch,
          "Voucher number format is not configured for Credit Note",
          "error"
        );
      }
      await dispatch(
        setDebCrdHT({
          iScrId: 44,
          iBranchId: session.Branch,
          iVenTypeId: 1, // same default as before
          strTransNo: objNo ? objNo.strTransNo : "",
          strVouchNo: objNo ? objNo.strUserNo : "",
          arrNoFormat: res.objEntNoFormat || [],
          arrEntHT: res.objEntCreditNote || [],
          arrVenType: res.objEntVenType || [],
          arrValidation: res.Transtab || [],
        })
      );
      TabOrderAssign(res.Transtab || []);
    }
  };
  const Search_CreditNote = async (strtext) => {
    setstrSearch(strtext);
    const session = await sessionParams();
    const objSearch = {
      iBranchId: session.Branch,
      iScrId: "",
      iPartyId: "",
      strColName: "All",
      strSearch: strtext,
      strDBName: session.DB,
    };
    // FIX: the endpoint is [HttpPost]; API_FETCH is a GET call, so the
    // search never worked
    const res = await API_POST(
      "CreditNote/Search_CreditNote/",
      objSearch,
      dispatch
    );
    if (res) dispatch(setEntDebCrdHT(res.objEntCreditNote || []));
  };
  const ClearClick = () => {
    dispatch(refresh_AccDebCrd());
    Load_CreditNote();
  };
  const Cancel_CreditNote = async () => {
    const session = await sessionParams();
    // FIX: the endpoint is [HttpPost]; this was a GET call (405), so Cancel
    // never worked. Body is {}, dispatch is the 3rd argument.
    const res = await API_POST(
      `CreditNote/Cancel_CreditNote/${_AccParem.iDebCrdId}/${session.DB}`,
      {},
      dispatch
    );
    if (res) {
      ClearClick();
      Show_Message(dispatch, res.strMessage, "success");
    }
  };
  const Save_CreditNote = async () => {
    if (savingRef.current) return;
    savingRef.current = true;
    try {
      const session = await sessionParams();
      const fmt = (_HTParem.arrNoFormat || [])[0] || {};
      const objInsUpdDeb = {
        // FIX: iScrId was not sent, so the duplicate voucher number check
        // ran with ScrId 0
        iScrId: 44,
        strPrefix: fmt.strPrefix,
        iBranchId: _AccParem.iBranchId,
        iNumSeqNo: fmt.iNumSeqNo,
        strCompCode: fmt.strCompCode,
        strFinanFrom: fmt.strFinanFrom,
        strCreNo: _AccParem.strVouchNo,
        strTransNo: _AccParem.strTransNo,
        dpCreDate: _AccParem.strVouchDate,
        iVenType: Number(_AccParem.iVenTypeId),
        iVenId: Number(_AccParem.iVenId) || 0,
        iCreId: Number(_AccParem.iDebCrdId) || 0,
        dAmount: Number(_AccParem.dAmount).toFixed(2),
        strRemark: String(_AccParem.strRemark || "").trim(),
        iVouchId: 0,
        iCallerScrId: 0,
        strFilter: "",
        strFilterColumn: "All",
        strSearch: "",
        strVenName: "",
        strDBName: session.DB,
      };
      const res = await API_POST(
        "CreditNote/InsUpd_CreditNote/",
        objInsUpdDeb,
        dispatch
      );
      if (res) {
        ClearClick();
        Show_Message(dispatch, res.strMessage, "success");
      }
    } finally {
      savingRef.current = false;
    }
  };
  const View_CreditNote = async (DebId) => {
    const session = await sessionParams();
    const res = await API_FETCH(
      `CreditNote/View_CreditNote/${DebId}/${session.DB}`,
      dispatch
    );
    if (res && res.objCreDetails) {
      const d = res.objCreDetails;
      dispatch(
        setDebCrdDeafult({
          iDebCrdId: Number(DebId),
          iScrId: _AccParem.iScrId,
          iBranchId: _AccParem.iBranchId,
          strTransNo: d.strTransNo,
          strVouchNo: d.strCreNo,
          // FIX: API sends dd-MM-yyyy, <input type="date"> needs yyyy-MM-dd
          strVouchDate: toISODate(d.dpCreDate),
          iVenTypeId: Number(d.iVenType ?? d.iVenTyp),
          iVenId: Number(d.iVenId) || 0,
          strVenName: d.strVenName || "",
          strRemark: d.strRemark || "",
          dAmount: (Number(d.dAmount) || 0).toFixed(2),
          isCancel: toBool(d.bCancelStatus),
        })
      );
    }
  };
  const TabOrderAssign = (EntProperties) => {
    const arrTab = (EntProperties || []).filter(
      (Data) => Data.isTabStop === true
    );
    // control name in the DB tab settings -> tab-order key
    const ctrlMap = {
      txtEntNo: "TransNoTab",
      dpEntDate: "TranDate",
      txtVouchNo: "VoucherTab",
      dpVouchDate: "VouchDateTap",
      txtVenName: "VenNameTab",
      cbVenType: "VenTypeTab",
      txtAmt: "AmountTab",
      txtRemark: "Remarktab",
      ArrTab: "ArrTab",
      lbVouchers: "ArrTab",
      FilterTab: "FilterTab",
      cbFilter: "FilterTab",
      SearchTab: "SearchTab",
      txtSearch: "SearchTab",
      btnSave: "BtnSavtab",
      btnClear: "BtnCleartab",
      btnDelete: "BtnDeletetab",
      BtnDeletetab: "BtnDeletetab",
      btnClose: "BtnClosetab",
      BtnClosetab: "BtnClosetab",
      btnCancel: "BtnCancel",
    };
    // FIX: this used to dispatch once per control, each time rebuilding the
    // WHOLE tab-order object from the same stale copy (and every control that
    // did not match fell back to the VOUCHER tab index), so all fields got
    // the same index. Build the object once, dispatch once.
    const objTab = { ..._TabParem };
    arrTab.forEach((p) => {
      const key = ctrlMap[p.strCtrlName];
      if (key) objTab[key] = p.iTabIndex;
    });
    dispatch(setAccDeCr_Taborder(objTab));
    const maxTab = arrTab.reduce(
      (mx, p) => Math.max(mx, Number(p.iTabIndex) || 0),
      0
    );
    sessionStorage.maxTab = maxTab;
    // cursor starts on Vendor Name (the web screen uses autoFocus there)
    setTimeout(() => {
      const el = document.querySelector(`[tabindex='${objTab.VenNameTab}']`);
      if (el && typeof el.focus === "function") el.focus();
    }, 150);
  };
  const KeyDown = (e) => {
    // Shift+Enter in the Remarks box is a new line, not "next field"
    if (e.key === "Enter" && e.shiftKey) return;
    var maxTab = Number(sessionStorage.maxTab);
    var ActiveIndex = document.activeElement.tabIndex;
    if (e.key === "Enter") {
      if (ActiveIndex >= 1 && ActiveIndex < maxTab) {
        if (ActiveIndex + 1 === _TabParem.ArrTab) {
          $(".ReactTable .rt-tbody .rt-tr:eq(0)").focus();
        } else {
          $("[tabindex='" + (ActiveIndex + 1) + "']").focus();
          $("[tabindex='" + (ActiveIndex + 1) + "']").select();
        }
      } else {
        $("[tabindex='" + 1 + "']").focus();
        $("[tabindex='" + 1 + "']").select();
      }
    }
    // Up / Down arrows move between fields, but inside the multi-line
    // Remarks box they must move the cursor
    const isTextArea = e.target && e.target.tagName === "TEXTAREA";
    if (e.key === "ArrowDown" && !isTextArea) {
      // stop the number / date input from also changing its own value
      e.preventDefault();
      if (ActiveIndex >= 1 && ActiveIndex < maxTab) {
        if (ActiveIndex + 1 === _TabParem.ArrTab) {
          $(".ReactTable .rt-tbody .rt-tr:eq(0)").focus();
        } else {
          $("[tabindex='" + (ActiveIndex + 1) + "']").focus();
          $("[tabindex='" + (ActiveIndex + 1) + "']").select();
        }
      } else {
        $("[tabindex='" + 1 + "']").focus();
        $("[tabindex='" + 1 + "']").select();
      }
    }
    if (e.key === "ArrowUp" && !isTextArea) {
      e.preventDefault();
      if (ActiveIndex > 0 && ActiveIndex <= maxTab) {
        if (ActiveIndex - 1 === _TabParem.ArrTab) {
          $(".ReactTable .rt-tbody .rt-tr:eq(0)").focus();
        } else {
          $("[tabindex='" + (ActiveIndex - 1) + "']").focus();
          $("[tabindex='" + (ActiveIndex - 1) + "']").select();
        }
      } else {
        if (maxTab - 1 === _TabParem.ArrTab) {
          $(".ReactTable .rt-tbody .rt-tr:eq(0)").focus();
        } else {
          $("[tabindex='" + (maxTab - 1) + "']").focus();
          $("[tabindex='" + (maxTab - 1) + "']").select();
        }
      }
    }
  };
  const PropertiesValidation = () => {
    // Vendor Type 6 (Manual Invoice) has no party
    const isNoParty = Number(_AccParem.iVenTypeId) === 6;
    const ValidateItem = (_HTParem.arrValidation || []).filter(
      (Data) => Data.isValidate === true
    );
    for (let i = 0; i < ValidateItem.length; i++) {
      let isInvalid = false;
      switch (ValidateItem[i].strCtrlName) {
        case "txtVouchNo":
          isInvalid = isEmpty(_AccParem.strVouchNo);
          break;
        case "dpVouchDate":
          isInvalid = isEmpty(_AccParem.strVouchDate);
          break;
        case "cbVenType":
          isInvalid = !Number(_AccParem.iVenTypeId);
          break;
        case "txtVenName":
          // the vendor ID decides, not the name text
          isInvalid = !isNoParty && !(Number(_AccParem.iVenId) > 0);
          break;
        case "txtRemark":
          isInvalid = isEmpty(_AccParem.strRemark);
          break;
        case "txtAmt":
          // FIX: dAmount is a string, so "=== 0" never matched
          isInvalid = !(Number(_AccParem.dAmount) > 0);
          break;
        default:
          break;
      }
      if (isInvalid) {
        Show_Message(dispatch, ValidateItem[i].strErrorMsg, "error");
        return false;
      }
    }
    return true;
  };
  return (
    <>
      <SideMenu ScrId={44} />
      <div className="Master-container">
        <MasterList
          ScrId={44}
          strSearchtxt={strSearch}
          tabOrder={_TabParem.SearchTab}
          Search={(val) => Search_CreditNote(val)}
          arrMasterData={_HTParem.arrEntHT}
          isImg={false}
          displayName="strCreNo"
          Parem1="iCreId"
          View_Data={(iDebid) => View_CreditNote(iDebid)}
          placeholder="Credit Note"
        />
        <div className="Master-card">
          <div className="Master-wrapper">
            <DebitCreditBody
              PartyUrl="CreditNote/View_Party/"
              KeyDown={KeyDown}
              onVoucherSettingClose={ClearClick}
            />
            <Messagedialogbox />
          </div>
          <AccountsButton
            iVouchId={_AccParem.iDebCrdId}
            iScrId={44}
            Save={(e) => {
              if (!PropertiesValidation()) return;
              if (!(_HTParem.arrNoFormat || []).length) {
                Show_Message(
                  dispatch,
                  "Voucher number format is not configured",
                  "error"
                );
              } else if (_AccParem.isCancel) {
                Show_Message(
                  dispatch,
                  "Cancelled Credit Note cannot be modified",
                  "info"
                );
              } else if (!Number(_AccParem.iVenTypeId)) {
                Show_Message(dispatch, "Please Select Vendor Type", "info");
              } else if (
                Number(_AccParem.iVenTypeId) !== 6 &&
                !(Number(_AccParem.iVenId) > 0)
              ) {
                Show_Message(dispatch, "Please Select Vendor", "info");
              } else if (!_AccParem.strVouchDate) {
                Show_Message(dispatch, "Please Select Credit Note Date", "info");
              } else if (!(Number(_AccParem.dAmount) > 0)) {
                Show_Message(dispatch, "Please Enter Valid Amount", "info");
              } else {
                Ask_Question(
                  dispatch,
                  Save_CreditNote,
                  "Do You Want to  Save CreditNote?"
                );
              }
            }}
            Clear={ClearClick}
            Cancel={(e) => {
              if (Number(_AccParem.iDebCrdId) === 0) {
                Show_Message(dispatch, "Please Select CreditNote", "info");
              } else if (_AccParem.isCancel) {
                Show_Message(
                  dispatch,
                  "Credit Note is already Cancelled",
                  "info"
                );
              } else {
                // FIX: dispatch was missing as the first argument
                Ask_Question(
                  dispatch,
                  Cancel_CreditNote,
                  "Do You Want to  Cancel CreditNote?"
                );
              }
            }}
            KeyDown={KeyDown}
          />
        </div>
      </div>
    </>
  );
}
export default CreditNote;